module.exports = __webpack_public_path__ + "img/Logo_corner_bottom_left.8812ea2c.jpg";